import './_styles.scss';
import React from 'react';
import { Input } from 'components';
import { FiLoader } from 'react-icons/fi';

export default ({ visible, state, onChangeEvent, onValidate, toggleView }) => {

  return (!!visible) && (
    <form className='Signup-Form' onSubmit={(e) => e.preventDefault()}>

      <div className="Title">Create Account</div>

      <div className="Placeholder">Your Name</div>

      <Input
        type='name'
        name='name'
        value={state.name}
        onChange={onChangeEvent}
        error={state.errors['name']}
      />

      <div className="Placeholder">Your Email Address</div>

      <Input
        type='email'
        name='email_address'
        value={state.email_address}
        onChange={onChangeEvent}
        error={state.errors['email_address']}
      />

      <div className="Placeholder">Your Password</div>

      <Input
        type='password'
        name='password'
        value={state.password}
        onChange={onChangeEvent}
        error={state.errors['password']}
      />

      <div className="Placeholder">Re-enter password</div>

      <Input
        type='password'
        name='confirm_password'
        value={state.confirm_password}
        onChange={onChangeEvent}
        error={state.errors['confirm_password']}
      />

      <button className='Login-Button' onClick={onValidate} disabled={state.loading}>
        {(state.loading) && <FiLoader className='loader'/>}
        <span className='button-text'>Create Account</span>
      </button>

      <div className="Change-View">
        <span className='text'>Already have Account?</span>
        <div className="link" onClick={() => toggleView()}>Sign In</div>
      </div>

    </form>
  )
}
